import { useForm } from "react-hook-form";
import { EMP, NAME, PROJECT_CODE, ROLE, TEAM } from "./consts";
import { useParams } from "react-router-dom";
import { schema, formValues } from "./validations";
import { getRequiredFields } from "@/lib/utils";
import { useGetEmployeeGrid, useGetRoles, useGetTeam } from "@/services";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useEffect } from "react";

const useTeamAssignment = () => {
  const { action, id } = useParams();
  const isEdit = action == routes.edit;
  const isView = action == routes.view;
  const projectData = useSelector(
    (state: RootState) => state.currentData.projectData
  );

  const form = useForm<formValues>({
    defaultValues: {
      [NAME]: projectData?.name || "",
      [PROJECT_CODE]: projectData?.code || "",
      [TEAM]: [{ [ROLE]: "", [EMP]: "" }],
    },
  });

  const requiredFields = getRequiredFields(schema);

  const { data: roleList, isLoading: isLoadingRoles } = useGetRoles();

  const {
    data: employeeList,
    isLoading: isEmployeeLoading,
  } = useGetEmployeeGrid({
    data: {
      pageNumber: 0,
      pageSize: -1,
      filters: [
        {
          field: "userType",
          value: "EMPLOYEE",
          operator: "EQUALS",
        },
      ],
      sort: [
        {
          field: "createdAt",
          direction: "DESC",
        },
      ],
    },
  });

  const { data: teamList, isLoading: isLoadingTeam } = useGetTeam({
    projectId: id as string,
    queryParams: {
      enabled: !!id,
    },
  });

  useEffect(() => {
    if (teamList?.data) {
      const team = teamList?.data?.map((data: any) => ({
        [ROLE]: data?.[ROLE],
        [EMP]: data?.[EMP],
      }));
      form.setValue(TEAM, team);
    }
  }, [teamList]);

  return {
    form,
    requiredFields,
    isEdit,
    isView,
    roleList,
    isLoadingRoles,
    employeeList,
    isEmployeeLoading,
    teamList,
    isLoadingTeam,
  };
};

export default useTeamAssignment;
